const user_devices = [
  {
    name: 'web_browser',
    label: 'Web Browser',
  },
  {
    name: 'mobile',
    label: 'Mobile',
  },
];

export default user_devices;
